<template>
  <div>
    <button
      v-if="!isNewDeviceEditor || actions.rf_retention_button1_text"
      class="rfmodal-button-yes primary-btn-p"
      :style="acceptButtonStyle"
      :disabled="!acceptButtonEnabled"
      @click="$emit('onAccept', 'accept')"
      v-html="actions.rf_retention_button1_text"
    ></button>
    <button
      v-if="
        isNewDeviceEditor
          ? actions.rf_settings_confirm_button_2_enabled === 'true' &&
            actions.rf_retention_button2_text
          : actions.rf_settings_confirm_button_2_enabled === 'true'
      "
      class="rfmodal-button-yes secondary-btn-p"
      :style="secondaryButtonStyle"
      :disabled="!acceptButtonEnabled"
      @click="$emit('onAccept', 'accept2')"
      v-html="actions.rf_retention_button2_text"
    ></button>
    <button
      v-if="
        isNewDeviceEditor
          ? actions.rf_settings_cancel_button_enabled === 'true' &&
            actions.rf_retention_button3_text
          : actions.rf_settings_cancel_button_enabled === 'true'
      "
      class="rfmodal-button-no"
      :style="cancelButtonStyle"
      @click="$emit('onDecline')"
      v-html="actions.rf_retention_button3_text"
    ></button>
  </div>
</template>

<script>
import PromoPreviewMixin from "@/utils/PromoPreviewMixin";

export default {
  name: "RfRetentionButtonsInner",
  mixins: [PromoPreviewMixin],
  props: {
    model: Object, // PromoPreviewMixin
    actions: Object,
    isNewDeviceEditor: { type: Boolean, default: false },
    acceptButtonEnabled: { type: Boolean, default: true },
    newButtonStyles: { type: Boolean, default: false }, // PromoPreviewMixin
  },
  emits: ["onAccept", "onDecline"],
};
</script>
